import { Box, Modal as MuiModal, styled } from "@mui/material";
import { ReactNode } from "react";

import { TButtonNewVariant } from "@/modules/irohana-components/elements/ButtonNew";
import { DialogFooter } from "@/modules/irohana-components/elements/Dialog/DialogFooter";
import { DialogHeader } from "@/modules/irohana-components/elements/Dialog/DialogHeader";
import { background } from "@/modules/irohana-components/theme/colors-new";
import { rounded } from "@/modules/irohana-components/theme/variables";
import { FCC } from "@/modules/irohana-components/types/common";

export type TModalProps = {
  isOpen: boolean;
  title?: ReactNode;
  /** Sub text under the title. Hidden when omitted. */
  description?: ReactNode;
  labelClose?: string;
  labelOk?: string;
  enableFooter?: boolean;
  enableCloseIcon?: boolean;
  hideBackdrop?: boolean;
  width?: number | string;
  height?: number | string;
  keepMounted?: boolean;
  preventCloseBackdrop?: boolean;
  disabledOk?: boolean;
  isLoadingOkBtn?: boolean;
  hiddenCloseBtn?: boolean;
  hiddenOkBtn?: boolean;
  variantOkBtn?: TButtonNewVariant;
  onOk?: () => void;
  onClose?: () => void;
};

export const Modal: FCC<TModalProps> = ({
  children,
  isOpen,
  title,
  description,
  labelClose,
  labelOk,
  isLoadingOkBtn,
  enableFooter = true,
  enableCloseIcon = true,
  hideBackdrop = false,
  keepMounted = false,
  width = 417,
  height,
  disabledOk = false,
  preventCloseBackdrop = false,
  variantOkBtn = "primary",
  onOk,
  onClose,
  hiddenCloseBtn,
  hiddenOkBtn,
}) => {
  return (
    <MuiModal
      open={isOpen}
      hideBackdrop={hideBackdrop}
      onClose={!preventCloseBackdrop ? onClose : undefined}
      sx={{ position: hideBackdrop ? "relative" : "fixed", display: "flex", justifyContent: "center", alignItems: "center" }}
      keepMounted={keepMounted}
    >
      <ModalContainer width={width} height={height}>
        <DialogHeader title={title} description={description} enableCloseIcon={enableCloseIcon} onClose={onClose} />
        <ModalBody>{children}</ModalBody>
        {enableFooter && (
          <DialogFooter
            cancelLabel={labelClose || "いいえ"}
            confirmLabel={labelOk || "はい"}
            confirmVariant={variantOkBtn}
            onCancel={onClose}
            onConfirm={onOk}
            isLoading={isLoadingOkBtn}
            disabledConfirm={disabledOk}
            hideCancel={hiddenCloseBtn}
            hideConfirm={hiddenOkBtn}
          />
        )}
      </ModalContainer>
    </MuiModal>
  );
};

const ModalContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  min-width: 417px;
  background-color: ${background.white};
  border-radius: ${rounded.md};
  max-height: 90vh;
  overflow: hidden;
  outline: none; /* Remove default focus outline */
  &:focus {
    outline: none;
  }
`;

const ModalBody = styled(Box)`
  padding: 0 24px;
  overflow: auto;
`;
